// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4762":"0923f911","9289":"6f624949"}[chunkId] + ".chunk.css";
};